import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import EditTeacher from "../components/structureComponent/editTeacherComponent";

export default function EditTeacherPage() {
    return (
        <Layout>
            <Header/>
            <EditTeacher/>
            <Footer/>
        </Layout>
    );
}